export class CriarCompromissoSignature {
  descricao: string;
  titulo: string;
  data_compromisso: Date;
  metadata: string;

  constructor(values: Partial<CriarCompromissoSignature> = {}) {
    Object.assign(this, values);
  }
} 